<template>
  <div>
    <!-- header area -->
    <div class="no-top-padding header-area">
      <div class="title">
        <!-- <h1>Dashboard Summary</h1> -->
        <!-- <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div
            class="widget widget-alpha widget-alpha--color-amaranth"
            style="background-color: transparent !important; box-shadow: none !important; margin-bottom: 0px; padding-bottom: 0px;"
        >-->
        <div
          class="top-widget-box performance"
          style="display: flex; flex-flow: row wrap; justify-content: space-between; align-items: center;padding: 16px 17px;"
        >
          <div class="top-widget-box__body">
            <h1>Dashboard Summary</h1>
          </div>
          <div class="top-widget-box__header" style="display: flex; flex-flow: column wrap;">
            <span class="stats_header_ _title">Total Devices</span>
            <h1 style="margin: 2px;">{{ filteredAllDevices.length }}</h1>
          </div>
        </div>
        <!-- </div>
        </div>-->

        <!-- <custom-date-picker :callback-func="handleOnChartReady">
        </custom-date-picker>-->
        <div class="col-md-12 col-sm-12 col-xs-12 mb-5" style="margin-bottom: 12px;">
          <div class="row">
            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12">
              <div class="widget widget-alpha widget-alpha--color-amaranth" style="height: 90%">
                <div class="top-widget-box performance">
                  <div class="top-widget-box__header">
                    <i class="fa fa-wifi fa-4x icon" style="color: #2ED47A;"></i>
                  </div>
                  <div class="top-widget-box__body">
                    <span class="stats_header__title">Online Devices</span>
                    <h1>{{ filteredOnlineDevices.length }}</h1>
                    <p class="top-subtitle">&nbsp;</p>
                    <p class="top-subtitle">Connected to the internet</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12">
              <div class="widget widget-alpha widget-alpha--color-amaranth" style="height: 90%">
                <div class="top-widget-box performance">
                  <div class="top-widget-box__header">
                    <i class="fa fa-ban fa-4x icon" style="color: #e74c3c;"></i>
                  </div>
                  <div class="top-widget-box__body">
                    <span class="stats_header__title">Offline Devices</span>
                    <h1>{{ filteredOffLineDevices.length }}</h1>
                      <p class="top-subtitle">&nbsp;</p>
                     <p class="top-subtitle">Not connected to the internet</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12">
              <div class="widget widget-alpha widget-alpha--color-amaranth">
                <div class="top-widget-box performance">
                  <div class="top-widget-box__header">
                    <i class="fa fa-exclamation fa-4x icon" aria-hidden="true"></i>
                  </div>
                  <div class="top-widget-box__body">
                    <span class="stats_header__title">Devices with alarm</span>
                    <h1>{{ filteredAlarmDevices.length }}</h1>
                      <p class="top-subtitle">&nbsp;</p>
                     <p class="top-subtitle">With alarm notifications</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12">
              <div class="widget widget-alpha widget-alpha--color-amaranth">
                <div class="top-widget-box performance">
                  <div class="top-widget-box__header">
                    <i
                      class="fa fa-exclamation-circle fa-4x icon"
                      aria-hidden="true"
                      style="color: #e74c3c;"
                    ></i>
                  </div>
                  <div class="top-widget-box__body">
                    <span class="stats_header__title">Critical Systems</span>
                    <h1>{{ criticalSystems.length }}</h1>
                      <p class="top-subtitle">&nbsp;</p>
                     <p class="top-subtitle">With Inverter not detected error</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- footer area -->
    <div class="footer-area col-md-12 col-sm-12 col-xs-12 mb-5">
      <div class="content">
        <!-- <h2>System status in VRM</h2> -->
        <div class="grid grid-1">
          <custom-box
            value="35W"
            title="Devices"
            icon="fa-calendar-plus-o "
            iconLabel="25C"
            color="#4790d0"
          ></custom-box>
          <custom-box value="0W" title="Unavailable" icon="fa-hourglass-end" color="#f7ab3e"></custom-box>
          <custom-box value="0W" title="Available" icon="fa-hourglass-end" color="#72b84ce6"></custom-box>
        </div>
        <div class="grid grid-2">
          <custom-box
            value="100.0%"
            title="Error"
            icon="fa-battery-quarter "
            iconLabel="Idle"
            voltage="53.99V"
            color="#fa716f"
            current="1.40A"
          ></custom-box>
          <custom-geo-box value="100.0%" title="Energy Generated"></custom-geo-box>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable ok */

import customBox from "./components/customBox";
import customGridBox from "./components/customGridBox";
import customGeoBox from "./components/customGeoBox";
import customChart from "./components/customChart";
import customDatePicker from "./components/customDatePicker";
import customPieChart from "./components/customPieChart";

import Vue from "vue";

import { HTTP as IOTHTTP } from "../../../store/actions";
import moment from "moment";

import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      inverterId: null
    };
  },
  computed: {
    ...mapGetters([
      "filteredAllDevices",
      "filteredOnlineDevices",
      "filteredOffLineDevices",
      "filteredAlarmDevices",
      "criticalSystems"
    ])
  },
  components: {
    // GreyPagination
    "custom-box": customBox,
    "custom-grid-box": customGridBox,
    "custom-geo-box": customGeoBox,
    "custom-chart": customChart,
    "custom-pie-chart": customPieChart,
    "custom-date-picker": customDatePicker
  },
  methods: {},
  mounted() {
    this.inverterId = this.$route.params.deviceId;
  }
};
</script>

<style lang="scss" scoped>
.top-subtitle{
  color: #999;
}
.title {
  margin-bottom: 50px;
}

.footer-area {
  background-color: #ffffff;
  padding-bottom: 100px;
}
.header-area {
  margin: 0 auto;
  width: 100%;
  max-width: 1200px;
  padding: 50px 0;
}

.content {
  margin: 0 auto;
  width: 100%;
  max-width: 960px;
  padding: 50px 0;
}

.no-top-padding {
  padding-top: 0;
}

.grid {
  display: grid;
  grid-gap: 20px;
}

.grid-1 {
  grid-template-columns: 0.5fr 0.5fr 1fr;
}

.grid-2 {
  margin-top: 20px;
  grid-template-columns: 0.5fr 1fr 0.5fr;
}

.box {
  background-color: white;
  border: 1px solid #f0f0f0;
  padding: 20px;
  height: 220px;
}

.small {
  display: block;
  margin-top: -10px;
  color: #999;
}

.chart-info {
  display: flex;
  margin-top: 30px;
}

.chart-section {
  margin-bottom: 30px;
}

.info-item {
  display: flex;
  align-items: center;

  i {
    margin-right: 5px;
  }

  & + .info-item {
    margin-left: 30px;
  }

  span {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/dashboard/summary.vue